import React, { Dispatch, FC, SetStateAction } from 'react';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { T_KEY } from '../../utils';
import { CurrentViewState, WorkExperienceViewStates } from '../../shared/types';
import workExperienceBIEvents from '../../utils/biEvents';
import { useMonitoring } from '../../../../utils/monitoring';
import { ImportErrorImage } from './assets/ImportErrorImage';

interface ImportErrorsProps {
    setCurrentViewState: Dispatch<SetStateAction<CurrentViewState>>;
    triggerLinkedInImport: (profileUrl: string) => void;
    profileUrl: string;
}

const ImportError: FC<ImportErrorsProps> = ({ setCurrentViewState, triggerLinkedInImport, profileUrl }) => {
    const { Providers, fireEvents } = useMonitoring();
    const onAddManuallyClick = () => {
        setCurrentViewState((currentViewState) => ({
            ...currentViewState,
            viewState: WorkExperienceViewStates.AddEdit,
        }));

        fireEvents({
            [Providers.BigQuery]: workExperienceBIEvents.clickedOnAddWorkExperience({ state: 'failed_state' }),
        });
    };

    const onRetryClick = () => {
        fireEvents({
            [Providers.BigQuery]: workExperienceBIEvents.clickOnImportWorkExperience({ state: 'failed_state' }),
        });
        triggerLinkedInImport(profileUrl);
    };

    return (
        <Stack direction="column" gap="8" alignItems="center">
            <ImportErrorImage />
            <Text textAlign="center">
                <I18n k={`${T_KEY}.import.error`} />
            </Text>
            <Stack gap="4">
                <Button
                    intent="secondary"
                    variant="outline"
                    onClick={onAddManuallyClick}
                    data-testId="add-experience-button"
                >
                    <I18n k={`${T_KEY}.import.add_it_yourself`} />
                </Button>
                <Button onClick={onRetryClick} data-testId="retry-button">
                    <I18n k={`${T_KEY}.import.retry`} />
                </Button>
            </Stack>
        </Stack>
    );
};

export default ImportError;
